import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/photoCode'

export const photoDashboardService = {
    searchDashboard
};

function searchDashboard(data) {
    return utilHelper.doRequest(`${relativeUrl}/searchDashboard`, 'POST', data)
}